//#region Styles
import {
    Container 
} from "./styles";
//#endregion
//#region Components
import StepIndex from "./components/StepIndex/StepIndex";
//#endregion

const StepIndexer = ({
    currentStep,
    descriptions 
}) => {
    return (
        <Container>
            {descriptions.map((text, idx) => {
                return (
                    <StepIndex 
                        key={idx}
                        step={idx + 1} 
                        passed={currentStep > idx + 1}
                        filling={currentStep === idx + 1}
                        isLast={idx === descriptions.length - 1}>
                        {text}
                    </StepIndex>
                );
            })}
        </Container>
    );
}

export default StepIndexer;